import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=67cd64b3&scoped=true"
import script from "./BankTransfer.vue?vue&type=script&lang=ts"
export * from "./BankTransfer.vue?vue&type=script&lang=ts"
import style0 from "./BankTransfer.vue?vue&type=style&index=0&id=67cd64b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cd64b3",
  null
  
)

export default component.exports